module.exports = __webpack_public_path__ + "static/media/yardnapha_got_1.4ad1e873.png";